import {Module} from 'vuex'
import {parametrage} from '@/shared/parametrage'
import Vue from 'vue'

const getOriginalState = () => {
  return {
    synoptique: null,
    suivis: null,
    pieces: null,
    remarques: null,
    microfilms: null,
    statistiques: null,
    syntheses: null,
    liens: null,
    affairesLiees: null,
    relationsProjet: null,
    etapes: null,
    oac: {
      // données spéciales dossiers OAC
      depot: null,
      circulations: null,
      syntheses: null,
      decisions: null,
      miseEnService: null,
      chantiers: null,
      prolongations: null,
      recours: null,
      enquetesPubliques: null,
      observations: null,
      fin: null
    },
    loadingDatas: []
  }
}

const checkNiveauxEtapes = (etape) => {
  if (!etape || !etape.niveau) {
    return
  }
  if (etape.niveau === 2 && (!etape.enfants || !etape.enfants.length)) {
    etape.niveau = 3
  }
  if (etape.enfants && etape.enfants.length) {
    etape.enfants.forEach((enfant) => checkNiveauxEtapes(enfant))
  }
  etape.visible = etape.niveau !== 3
}

export const dossierStore: Module<any, any> = {
  namespaced: true,
  state: getOriginalState(),
  getters: {
    isDonneeLoading: (state) => (typeDonnee) => state.loadingDatas.includes(typeDonnee),
    isDossierACDemat: (state) => state.synoptique && state.synoptique.origineDossier === parametrage.originesDossier.ACDEMAT
  },
  mutations: {
    addLoadingData(state, nomData) {
      if (!state.loadingDatas.includes(nomData)) {
        state.loadingDatas.push(nomData)
      }
    },
    removeLoadingData(state, nomData) {
      state.loadingDatas.splice(state.loadingDatas.indexOf(nomData), 1)
    },
    setSynoptique(state, dossier) {
      state.synoptique = dossier
    },
    setSyntheses(state, syntheses) {
      state.syntheses = syntheses
    },
    setStatistiques(state, statistiques) {
      state.statistiques = statistiques
    },
    setRemarques(state, remarques) {
      state.remarques = remarques
    },
    setMicrofilms(state, microfilms) {
      state.microfilms = microfilms
    },
    setSuivis(state, suivis) {
      state.suivis = suivis
    },
    setLiens(state, liens) {
      state.liens = liens
    },
    setAffairesLiees(state, affairesLiees) {
      state.affairesLiees = affairesLiees
    },
    setPieces(state, pieces) {
      state.pieces = pieces
    },
    setRelationsProjet(state, relations) {
      state.relationsProjet = relations
    },
    addRelationsProjet(state, {relations = [], idDossierLie}) {
      const parent = state.relationsProjet.find((rel) => rel.idDossierLie === idDossierLie)

      if (parent) {
        Vue.set(parent, 'enfants', relations)
      }
    },
    setEtapes(state, etapes) {
      if (etapes) {
        // héritage LDV AC-Demat : une sous-étape de niveau 2 qui n'a pas d'enfant est considéré à l'affichage comme
        // une sous-étape de niveau 3
        etapes.forEach((etape) => checkNiveauxEtapes(etape))

        const etapeFin = etapes.find((etape) => etape.code === 'FIN_DOSSIER')

        if (etapeFin) {
          state.oac.fin = {
            dateFin: etapeFin.dateDebut
          }
        }
      }

      state.etapes = etapes
    },
    setDepot(state, depot) {
      state.oac.depot = depot
    },
    setCirculations(state, circulations) {
      state.oac.circulations = circulations
    },
    setSynthesesOac(state, syntheses) {
      state.oac.syntheses = syntheses
    },
    setDecisions(state, decisions) {
      state.oac.decisions = decisions
    },
    setMiseEnService(state, miseEnService) {
      state.oac.miseEnService = miseEnService
    },
    setChantiers(state, chantiers) {
      state.oac.chantiers = chantiers
    },
    setProlongations(state, prolongations) {
      state.oac.prolongations = prolongations
    },
    setRecours(state, recours) {
      state.oac.recours = recours
    },
    setEnquetesPubliques(state, enquetesPubliques) {
      state.oac.enquetesPubliques = enquetesPubliques
    },
    setObservations(state, observations) {
      state.oac.observations = observations
    },
    reinitialiser(state) {
      Object.assign(state, getOriginalState())
    }
  }
}
